const commonQuestions = [
    {
        id: "q_1",
        q: "كيف أطلب من الموقع؟",
        ans: "سجل دخول > حط المنتج بالسلة > أدخل السلة > قم يإتمام الطلب"
    },
    {
        id: "q_2",
        q: "كيف أطلب من الموقع؟",
        ans: "سجل دخول > حط المنتج بالسلة > أدخل السلة > قم يإتمام الطلب"
    },
    {
        id: "q_3",
        q: "كيف أطلب من الموقع؟",
        ans: "سجل دخول > حط المنتج بالسلة > أدخل السلة > قم يإتمام الطلب"
    },
    {
        id: "q_4",
        q: "كيف أطلب من الموقع؟",
        ans: "سجل دخول > حط المنتج بالسلة > أدخل السلة > قم يإتمام الطلب"
    },
    {
        id: "q_5",
        q: "كيف أطلب من الموقع؟",
        ans: "سجل دخول > حط المنتج بالسلة > أدخل السلة > قم يإتمام الطلب"
    },
    {
        id: "q_6",
        q: "كيف أطلب من الموقع؟",
        ans: "سجل دخول > حط المنتج بالسلة > أدخل السلة > قم يإتمام الطلب"
    },
    {
        id: "q_7",
        q: "كيف أطلب من الموقع؟",
        ans: "سجل دخول > حط المنتج بالسلة > أدخل السلة > قم يإتمام الطلب"
    },
    {
        id: "q_8",
        q: "كيف أطلب من الموقع؟",
        ans: "سجل دخول > حط المنتج بالسلة > أدخل السلة > قم يإتمام الطلب"
    },
    {
        id: "q_9",
        q: "كيف أطلب من الموقع؟",
        ans: "سجل دخول > حط المنتج بالسلة > أدخل السلة > قم يإتمام الطلب"
    },
    {
        id: "q_10",
        q: "كيف أطلب من الموقع؟",
        ans: "سجل دخول > حط المنتج بالسلة > أدخل السلة > قم يإتمام الطلب"
    }
];

export default commonQuestions;
